import {BaseAnalyticsEvent} from "../../../../../infrastructure/models/analytics/base-analytics-event";

export class BettingPromotionDisplayAnalyticsEvent extends BaseAnalyticsEvent {
  version: String;
  timesShown: Number;
  bookieId: Number;
  imageUrl: String;
  mainText: String;
  secondaryTextTerm: String;

  constructor(params) {
    super('', 'display', 'betting-promotion');

    this.version = params.version;
    this.timesShown = params.timesShown;
    this.bookieId = params.bookieId;
    this.imageUrl = params.imageUrl;
    this.mainText = params.mainText;
    this.secondaryTextTerm = params.secondaryTextTerm;
  }

  get properties() {
    const properties = super.properties;

    properties.version = this.version;
    properties.timesShown = this.timesShown;
    properties.bookieId = this.bookieId;
    properties.imageUrl = this.imageUrl;
    properties.mainText = this.mainText;
    properties.secondaryTextTerm = this.secondaryTextTerm;

    return properties;
  }

}
